import React from 'react'

const BlogList = React.lazy(() => import('./BlogList'))

export default BlogList
